module.exports = __webpack_public_path__ + "static/media/IMG_3070.85f3e3d0.JPG";